import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
export function useChargesNavigation() {
    const navigate = useNavigate();
    const handleBackToCharges = useCallback(() => {
        navigate('/conta-pj/receber');
    }, [navigate]);
    const handleViewChargeDetails = useCallback((chargeId) => {
        console.log('View details for charge:', chargeId);
    }, []);
    const handleViewChargePDF = useCallback((chargeId) => {
        navigate(`/conta-pj/receber/pdf/${chargeId}`);
    }, [navigate]);
    const handleCancelCharge = useCallback((chargeId) => {
        console.log('Cancel charge:', chargeId);
    }, []);
    const handleDownloadSlip = useCallback((chargeId) => {
        console.log('Download slip for charge:', chargeId);
    }, []);
    return {
        handleBackToCharges,
        handleViewChargeDetails,
        handleViewChargePDF,
        handleCancelCharge,
        handleDownloadSlip,
    };
}
